import LiveService from '../javascript/liveService/LiveService'

// Countdown Implementation
const liveServiceElements = Array.from(
  document.querySelectorAll('[data-live-service]'),
)

liveServiceElements.forEach((element) => {
  const {
    liveEndDate,
    nextStartDate,
    nextEndDate,
    nextEmbedSelector,
  } = element.dataset

  const nextEmbed = $(nextEmbedSelector).html()

  const service = new LiveService({
    element,
    liveEndDate,
    nextStartDate,
    nextEndDate,
    nextEmbed,
  })
})
